var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M513.871448 913.619862a21.256828 21.256828 0 0 1-18.078896-10.063448l-51.588414-84.568276a21.186207 21.186207 0 0 1 36.051862-22.033655l33.368276 54.731034 195.866483-326.091034c0.211862-0.423724 0.494345-0.812138 0.741517-1.200552a234.072276 234.072276 0 0 0 42.125241-134.355862c0-130.895448-107.873103-237.391448-240.428138-237.391448-132.625655 0-240.428138 106.496-240.428138 237.391448 0 47.527724 14.124138 93.360552 40.88938 132.555034l0.564965 0.847449 117.300966 191.876414a21.186207 21.186207 0 0 1-7.026759 29.060413 21.186207 21.186207 0 0 1-29.095724-7.026758l-116.912552-191.382069a275.703172 275.703172 0 0 1-48.057379-155.930483c0-154.164966 126.834759-279.657931 282.765241-279.657931s282.765241 125.492966 282.765242 279.657931a276.338759 276.338759 0 0 1-49.363862 157.943172l-213.380414 355.398621a21.009655 21.009655 0 0 1-18.078897 10.24z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 533.080276c-75.034483 0-136.086069-61.051586-136.086069-136.086069S436.965517 260.943448 512 260.943448s136.086069 61.051586 136.086069 136.086069-61.051586 136.050759-136.086069 136.050759z m0-229.905655c-51.729655 0-93.784276 42.089931-93.784276 93.819586s42.054621 93.784276 93.784276 93.784276 93.784276-42.054621 93.784276-93.784276-42.054621-93.819586-93.784276-93.819586z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.03e9c9293a801c8736577e41e626506a.svg";
export { ForwardRef as ReactComponent };